$(function () {
    if ($('#chart-odo').length) {

        am4core.useTheme(am4themes_animated);

        let num = Math.ceil(window.odo.length / 7);

        for (var idx in window.odo) {
            if (window.odo.hasOwnProperty(idx)) {
                if ((idx - 1) % num === 0 || !window.odo[idx].status) {
                    window.odo[idx].lClass = window.odo[idx].status ? 's-lab' : 's-lab rdc';
                }
            }
        }

        let lbClass = window.odo.length > 4 ? '' : 'vis';

        window.maxOdo = Math.max.apply(Math, window.odo.map(function (o) {
            return o.mileage;
        })) * 1.02;

        am4core.ready(function () {

            let chart = am4core.create('chart-odo', am4charts.XYChart);
            chart.paddingRight = 0;
            chart.paddingLeft = 0;

            chart.colors.step = 2;

            chart.data = window.odo;

            let dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.renderer.minGridDistance = 80;
            dateAxis.renderer.grid.template.location = 0.5;
            dateAxis.startLocation = 0.3;
            dateAxis.endLocation = 0.7;
            dateAxis.dataFields.category = 'year';

            dateAxis.renderer.grid.template.strokeOpacity = 1;
            dateAxis.renderer.grid.template.stroke = am4core.color('#eee');
            dateAxis.renderer.grid.template.strokeWidth = 1;
            //dateAxis.groupData = true;
            //dateAxis.baseInterval = {'timeUnit': 'year', 'count': 1};

            //dateAxis.dateFormats.setKey('month', '[bold #0493D3]MM / yyyy');
            //dateAxis.periodChangeDateFormats.setKey('month', '[#999]yyyy');
            dateAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + text;
            });

            let axisTooltip = dateAxis.tooltip;
            axisTooltip.background.fill = am4core.color('#fff');
            axisTooltip.background.strokeWidth = 0;
            axisTooltip.background.pointerLength = 0;
            axisTooltip.autoTextColor = false;
            axisTooltip.label.fill = am4core.color('#20416C');
            axisTooltip.label.fontWeight = '900';

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + text;
            });

            let axisYTooltip = valueAxis.tooltip;
            axisYTooltip.background.fill = am4core.color('#fff');
            axisYTooltip.background.strokeWidth = 0;
            axisYTooltip.background.pointerLength = 0;
            axisYTooltip.autoTextColor = false;
            axisYTooltip.label.fill = am4core.color('#20416C');
            axisYTooltip.label.fontWeight = '900';

            valueAxis.renderer.grid.template.strokeOpacity = 0;

            valueAxis.max = window.maxOdo * 1.06;

            chart.cursor = new am4charts.XYCursor();

            function createAxisAndSeries(field, name) {

                let series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.categoryX = 'year';

                series.strokeWidth = 3;
                series.name = name;
                series.tensionX = 0.8;
                series.tensionY = 0.9;
                series.minBulletDistance = 25;

                series.tooltip.getFillFromObject = false;
                series.tooltip.background.cornerRadius = 8;
                series.tooltip.background.fill = am4core.color('#f5f5f5');

                let shadow = series.tooltip.background.filters.getIndex(0);
                shadow.dx = 0;
                shadow.dy = 5;
                shadow.blur = 8;
                shadow.color = am4core.color('#999');

                series.tooltipHTML = `<div class="tt-chart t-{class}"><div class="{class}">{valueY} mi</div><div class="tt-img"><img src="/img/fail-ico.svg" alt=""></div><div class="tt-txt">{text}</div></div>`;
                series.tooltip.pointerOrientation = 'vertical';
                series.tooltip.dy = -10;

                let bullet = series.bullets.push(new am4charts.Bullet());
                let image = bullet.createChild(am4core.Image);
                image.propertyFields.href = 'bullet';
                image.width = 20;
                image.height = 20;
                image.horizontalCenter = 'middle';
                image.verticalCenter = 'middle';

                let bullet2 = series.bullets.push(new am4charts.LabelBullet());

                bullet2.label.dy = -19;
                bullet2.label.fill = am4core.color('#20416C');
                bullet2.label.html = `<b class="c-lb ${lbClass} {lClass}">{valueY} mi</b>`;

                series.fill = am4core.color('#20416C');
                series.stroke = series.fill;

            }

            createAxisAndSeries('mileage', 'Mileage');
        });
    }

    const setChartYear = function () {
        am4core.ready(function () {
            let chart = am4core.create('chart-year', am4charts.XYChart);
            chart.paddingRight = 0;
            chart.paddingLeft = 0;

            chart.colors.step = 2;

            chart.data = window.chartYear;

            let dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.renderer.minGridDistance = 75;
            dateAxis.renderer.grid.template.location = 0.5;
            dateAxis.dataFields.category = 'year';
            dateAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + text;
            });
            dateAxis.renderer.grid.template.strokeOpacity = 1;
            dateAxis.renderer.grid.template.stroke = am4core.color('#eee');
            dateAxis.renderer.grid.template.strokeWidth = 1;

            let axisTooltip = dateAxis.tooltip;
            axisTooltip.background.fill = am4core.color('#fff');
            axisTooltip.background.strokeWidth = 0;
            axisTooltip.background.pointerLength = 0;
            axisTooltip.autoTextColor = false;
            axisTooltip.label.fill = am4core.color('#20416C');
            axisTooltip.label.fontWeight = '700';

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + '$' + text;
            });

            let axisYTooltip = valueAxis.tooltip;
            axisYTooltip.background.fill = am4core.color('#fff');
            axisYTooltip.background.strokeWidth = 0;
            axisYTooltip.background.pointerLength = 0;
            axisYTooltip.autoTextColor = false;
            axisYTooltip.label.fill = am4core.color('#20416C');
            axisYTooltip.label.fontWeight = '700';

            valueAxis.renderer.grid.template.strokeOpacity = 0;

            function createAxisAndSeries(field, name) {

                let series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.categoryX = 'year';

                series.strokeWidth = 3;
                series.name = name;
                series.tensionX = 0.8;
                series.tensionY = 0.8;
                series.minBulletDistance = 25;

                series.tooltip.getFillFromObject = false;
                series.tooltip.background.cornerRadius = 5;
                series.tooltip.background.fill = am4core.color('#fff');

                let shadow = series.tooltip.background.filters.getIndex(0);
                shadow.dx = 0;
                shadow.dy = 5;
                shadow.blur = 8;
                shadow.color = am4core.color('#999');

                series.tooltipHTML = `<div class="tt-chart"><div class="blc">\${valueY}</div></div>`;
                series.tooltip.pointerOrientation = 'vertical';

                let bullet = series.bullets.push(new am4charts.Bullet());
                let image = bullet.createChild(am4core.Image);
                image.href = '/img/bullet-bl.svg';
                image.width = 20;
                image.height = 20;
                image.horizontalCenter = 'middle';
                image.verticalCenter = 'middle';

                series.fill = am4core.color('#20416C');
                series.stroke = series.fill;
            }

            createAxisAndSeries('price', 'Price');

            chart.legend = new am4charts.Legend();
            chart.cursor = new am4charts.XYCursor();

        });
    }

    const setChartMileage = function () {
        am4core.ready(function () {

            let chart = am4core.create('chart-mileage', am4charts.XYChart);
            chart.paddingRight = 0;
            chart.paddingLeft = 0;

            chart.colors.step = 2;

            chart.data = window.chartMileage;

            let dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.renderer.minGridDistance = 100;
            dateAxis.dataFields.category = 'mileage';
            dateAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + text + ' mi';
            });
            dateAxis.renderer.grid.template.strokeOpacity = 1;
            dateAxis.renderer.grid.template.stroke = am4core.color('#eee');
            dateAxis.renderer.grid.template.strokeWidth = 1;

            let axisTooltip = dateAxis.tooltip;
            axisTooltip.background.fill = am4core.color('#fff');
            axisTooltip.background.strokeWidth = 0;
            axisTooltip.background.pointerLength = 0;
            axisTooltip.autoTextColor = false;
            axisTooltip.label.fill = am4core.color('#20416C');
            axisTooltip.label.fontWeight = '700';

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.renderer.labels.template.adapter.add('text', function (text) {
                return '[#999]' + '$' + text;
            });

            let axisYTooltip = valueAxis.tooltip;
            axisYTooltip.background.fill = am4core.color('#fff');
            axisYTooltip.background.strokeWidth = 0;
            axisYTooltip.background.pointerLength = 0;
            axisYTooltip.autoTextColor = false;
            axisYTooltip.label.fill = am4core.color('#20416C');
            axisYTooltip.label.fontWeight = '700';

            valueAxis.renderer.grid.template.strokeOpacity = 0;

            function createAxisAndSeries(field, name) {

                let series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.categoryX = 'mileage';

                series.strokeWidth = 3;
                series.name = name;
                series.tooltipText = '{name}: $[bold]{valueY}[/]';
                series.tensionX = 0.8;
                series.tensionY = 0.8;
                series.minBulletDistance = 35;

                series.tooltip.getFillFromObject = false;
                series.tooltip.background.cornerRadius = 5;
                series.tooltip.background.fill = am4core.color('#fff');

                let shadow = series.tooltip.background.filters.getIndex(0);
                shadow.dx = 0;
                shadow.dy = 5;
                shadow.blur = 8;
                shadow.color = am4core.color('#999');

                let clr = field === 'auction' ? 'lblc' : 'blc';
                series.tooltipHTML = `<div class="tt-chart"><div class="${clr}">{name}: \${valueY}</div></div>`;

                series.tooltip.pointerOrientation = 'vertical';

                let bullet = series.bullets.push(new am4charts.Bullet());
                let image = bullet.createChild(am4core.Image);

                image.width = 20;
                image.height = 20;
                image.horizontalCenter = 'middle';
                image.verticalCenter = 'middle';

                if (field === 'auction') {
                    image.href = '/img/bullet-or.svg';
                    series.fill = am4core.color('#00AFDB');
                } else {
                    image.href = '/img/bullet-bl.svg';
                    series.fill = am4core.color('#20416C');
                }
                series.stroke = series.fill;
            }

            createAxisAndSeries('auction', 'Auction Price');
            createAxisAndSeries('dealer', 'Dealer Price');

            chart.legend = new am4charts.Legend();
            chart.cursor = new am4charts.XYCursor();

        });
    }

    if (!window.chartYear || !window.chartMileage) {
        let id = $('#report-id').val();
        $.ajax({
            method: 'POST',
            url: window.chartUrl,
            data: {reportId: id},
            success: function (response) {
                if (!response.year && !response.mileage) {
                    return;
                }

                if (!response.year.length && !response.mileage.length) {
                    return;
                }

                $('#price-charts').removeClass('d-none');

                if (response.year) {
                    $('#ch-year').removeClass('d-none');
                    window.chartYear = response.year;
                    setChartYear();
                }

                if (response.mileage) {
                    $('#ch-mileage').removeClass('d-none');
                    window.chartMileage = response.mileage;
                    setChartMileage();
                }
            },
            error: function (error) {
                console.log(error);
            },
        });
    } else {
        $('#price-charts').removeClass('d-none');

        if (window.chartYear && window.chartYear.length) {
            $('#ch-year').removeClass('d-none');
            setChartYear();
        }

        if (window.chartMileage && window.chartMileage.length) {
            $('#ch-mileage').removeClass('d-none');
            setChartMileage();
        }
    }
});
